const stickyTexts = document.querySelectorAll('.prad--sticky-text');
const stickyTextObservers = [];
const stickyTextSpyItems = [];

for (let i = 0; i < stickyTexts.length; i++) {

    var spyNav = stickyTexts[i].querySelector(".spy-navigation");
    var stickyTextID = stickyTexts[i].querySelector(".sticky-text__container").id;
    var stickyTextArticles = [...stickyTexts[i].querySelectorAll(".item")];

    stickyTextSpyItems[stickyTextID] = (entries, observer) => {
        entries.forEach((entry) => {
            const { id } = entry.target;
            const spyNavigation = document.querySelector('#spy-navigation-' + entry.target.dataset.spyNavigationId).getAttribute('data-spy-navigation-reference');
            const spy = document.querySelector('#spy-navigation-' + entry.target.dataset.spyNavigationId + ' [href="#' + id + '"]');
            var idArray = id.split('-');
            idArray.pop();
            spy.classList.remove("active");
            if (!entry.isIntersecting) return;
            spy.classList.add("active");
            if (window.dataLayer) {
                dataLayer.push({
                    'event': 'dataLayerEvent',
                    'eventCategory': 'spy navigation',
                    'eventAction': 'activate',
                    'eventLabel': 'pos:body_section:' + idArray.join(' ') + '_spy-navigation:' + spyNavigation
                });
            }


        });
    };

    var windowInnerHeight = window.innerHeight;
    var bottomRootMargin = window.innerHeight - 160;

    stickyTextObservers[stickyTextID] = new IntersectionObserver(stickyTextSpyItems[stickyTextID], {
        rootMargin: "-160px 0% -" + bottomRootMargin + "px 0%",
        root: document
    });

    stickyTextArticles.forEach((article) => stickyTextObservers[stickyTextID].observe(article));
}

jQuery('.toc__skip').on('click', function(e) {
    var $scrollTo = jQuery(this).closest('.prad--sticky-text').find('.bottom');
    var $container = jQuery("html,body");
    $container.animate({scrollTop: $scrollTo.offset().top - 200, scrollLeft: 0}, 300);
    e.preventDefault();
    return false;
});

jQuery('.toc__item').on('click', function(e) {
    jQuery('.toc__item').removeClass('active');
    jQuery(this).addClass('active');
    var $scrollTo = jQuery(jQuery(this).attr('href'));
    var $container = jQuery("html,body");
    $container.animate({scrollTop: $scrollTo.offset().top - 150, scrollLeft: 0}, 300);
    e.preventDefault();
    e.propagationStopped = true;
    return false;
});